<template>
    <div class="mediver-login-container">
        <div class="mediver-login-logo">
            <h2 class="main-title">Electroceuticals</h2>
            <div class="sub-title">비밀번호 찾기</div>
        </div>
        <form class="mediver-login-box" @submit.prevent="findPassword">
            <input
                v-model="email"
                type="email"
                class="login-input"
                placeholder="이메일"
                autocomplete="username"
            />
            <input
                v-model="name"
                type="text"
                class="login-input"
                placeholder="이름 (실명)"
                autocomplete="name"
            />
            <button type="submit" class="login-btn">비밀번호 찾기</button>
            <div v-if="result" class="login-error" style="color:#1976d2;">{{ result }}</div>
            <div class="login-links">
                <span class="link" @click="$emit('toLogin')">로그인 화면</span>
                <span class="divider">|</span>
                <span class="link" @click="$emit('toRegister')">회원가입</span>
                <span class="divider">|</span>
                <span class="link" @click="$emit('toFindId')">아이디 찾기</span>
            </div>
        </form>
    </div>
</template>

<script>
import api, {urls} from '@/api'

export default {
    name: "Password",
    data() {
        return {
            email: "admin@osangtech.co.kr",
            name: "홍길동",
            result: ""
        };
    },
    methods: {
        async findPassword() {
            if (!this.name) {
                alert("이름을 입력해주세요.");
                return;
            }
            if (!this.email) {
                alert("휴대폰 번호를 입력해주세요.");
                return;
            }
            api.post(urls.login.findPassword, { name: this.name,
                email: this.email
            })
                .then(response => {
                    const res = response.data;

                    if (res.password) {
                        // 성공 시 아이디 결과를 화면에 표현
                        this.result = `회원님의 password는 "${res.password}" 입니다.`;
                    } else {
                        // 실패 시 메시지 표시
                        this.result = res.message || '일치하는 회원정보가 없습니다.';
                    }
                })
                .catch(err => {
                    this.result = '비밀번호 찾기 중 오류가 발생했습니다.';
                    console.error(err);
                });
        }
    }
};
</script>

